import Widget from '../../../src/dashboard/Widget.jsx';
import Utility from '../../../src/core/Utility';
import PresetStatus from '../../../src/dashboard/PresetStatus';
import Translate from '../../../src/core/Translate.js';
// import PresetService from './PresetService.js';

export class StarterPreset {
	constructor(meta, store, isReadOnly = true, options = {}) {
		this.meta = meta;
		this.status = PresetStatus.Ready;
		this.store = store;
		this.guid = meta.guid;
		this.layout = meta.layout;
		this.token;

		console.warn(meta)

		// this.initInstantDataSource();

		this.widgets = [];
		this.isReadOnly = isReadOnly;
		this.options = options;
		this.isActive = meta.is_active;
		this.name = this.meta.name;
	}

	initLayout() {
		var self = this;
		return LayoutEngine.createBox(self.layout, false, {
			onDrag: (box, em, ed) => {
				// console.info('onDrag!!!!!!!!!!!!!!!');
			},
			onDrop: (box, event, targetDockId) => {
				// console.info('onDrop!!!!!!!!!!!!!!!');
			},
			onAppend: function(box, event, targetDockId) {
			},
			onModify: function(box) {
				//console.info('onModify!');
			},
			onDelete:  Utility.debounce(function(box) {
				self.resizeWidgets.call(self);
			}, 200),
			'afterResize': function(row, box) {
				console.info('afterResize!');
				self.resizeWidgets.call(self);
			}
		});
	}

	resetWidget(currentWidgets) {
		this.activeWidgets();
	}

	initWidget() {
		this.meta.widgets.forEach(ctx => {
			var w = new Widget(ctx, this.store, {
				'isReadOnly': this.isReadOnly,
				'elDock': this.options.el,
				'events': {
					'rendered': this.onWidgetRenderedEvent.bind(this),
					'infoClick': this.onWidgetInfoClick.bind(this),
					'closeClick': this.onWidgetCloseClick.bind(this),
					'failClick': this.onWidgetFailClick.bind(this),
					'titleChanged': this.onWidgetTitleChanged.bind(this),
					'filtered': this.onWidgetFiltered.bind(this),
					'filterReset': this.onWidgetFilterReset.bind(this),
					'contextChanged': this.onWidgetContextChanged.bind(this)
				},
				'theme': this.options.theme,
				'starter': true
			});
			this.widgets.push(w);
			w.resume();
		});
		this.status = PresetStatus.Active;
	}

	onWidgetInfoClick(w) {
		this.options.onInfoClick(w);
	}

	onWidgetRenderedEvent(service) {
		var e = new Event('themeChange');
		if(service instanceof DashboardWidget) {
			service.dispatchEvent(e);
		}
	}

	onWidgetFailClick(w) {
		this.options.onFailClick(w);
	}

	//removed contents as useless in starter screen as below.
	onWidgetCloseClick(w) {}
	onWidgetTitleChanged(newval) {}
	onWidgetContextChanged() {}
	onWidgetFiltered(widget, datasource, filterString) {}
	onWidgetFilterReset(widget, datasource) {}


	activeWidgets() {
		this.widgets.forEach(w => {
			w.resume();
		});
	}

	resume() {
		// if(this.status == PresetStatus.Ready) {
		this.initWidget();
		// }
		// else {
		// 	this.activeWidgets();
		// }
	}

	suspend() {
		this.widgets.forEach(w => {
			w.suspend();
		});
		this.widgets = [];
	}

	render(el) {
		this.rootbox = this.initLayout();
		this.rootbox.appendTo(el);
	}

	resizeWidgets() {
		this.widgets.forEach(widget => {
			if(!!widget.rendered) {
				var e = new Event('resize');
				widget.rendered.dispatchEvent(e);
			}
		});
	}

	setTheme(param) {
		this.widgets.forEach(w => {
			w.setTheme(param);
			if(!!w.rendered && typeof w.rendered.dispatchEvent === 'function') {
				var e = new Event('themeChange');
				e.detail = param;
				w.rendered.dispatchEvent(e);
			}

			// legacy
			if(!!w.rendered && typeof w.rendered.setStyle === 'function') {
				w.rendered.setStyle(param);
			}
		});
	}

	updateWidget(ctx) {
		var w = this.widgets.find(w => {
			return w.guid == ctx.guid;
		});
		w.updateContext(ctx);
	}
}


// WEBPACK FOOTER //
// ./resources/WEB-INF/package/system/starter/StarterPreset.js